import React from 'react'

export const FlatFooter = () => {
  return (
    <div
      className="py-4 flex items-center justify-center border-solid
    border-gray-200 border border-b-0 border-r-0 border-l-0 shadow-sm mt-auto"
    >
      <p className="text-gray-500">
        Info Solar © 1995-{new Date().getFullYear()}. Todos os direitos
        reservados.
      </p>
    </div>
  )
}
